module.exports = __webpack_public_path__ + "media/application/images/ui/close-button-fbdc8dd25c9b2e2e6dab1a36ff84d7bf.png";